var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 16.5C33 7.3873 25.6127 0 16.5 0C7.3873 0 0 7.3873 0 16.5C0 25.6127 7.3873 33 16.5 33C25.6127 33 33 25.6127 33 16.5Z",
    fill: "#1275B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5148 9.0661C12.5148 10.1675 11.56 11.0604 10.3824 11.0604C9.20469 11.0604 8.25 10.1675 8.25 9.0661C8.25 7.96466 9.20469 7.07178 10.3824 7.07178C11.56 7.07178 12.5148 7.96466 12.5148 9.0661Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5415 12.5259H12.1866V23.5713H8.5415V12.5259Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0552 12.5263H14.4102V23.5717H18.0552C18.0552 23.5717 18.0552 20.0945 18.0552 17.9203C18.0552 16.6153 18.5009 15.3046 20.2787 15.3046C22.288 15.3046 22.2759 17.0124 22.2665 18.3354C22.2543 20.0648 22.2835 21.8297 22.2835 23.5717H25.9286V17.7421C25.8977 14.0199 24.9277 12.3047 21.7367 12.3047C19.8417 12.3047 18.667 13.165 18.0552 13.9434V12.5263Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.8072e8c06ec9245268e28bfc39875816.svg";
export { ForwardRef as ReactComponent };